import { takeEvery, call, put } from 'redux-saga/effects';
import { apiPost } from '../core/dapi';
import { getCareerLeadsUrl } from '../core/dapi/careerLeads';
import { careerFormSubmitting, careerFormReceived, careerFormError } from '../ducks/careers';

const SUBMIT_CAREER_FORM_TO_SLACK = 'saga/SUBMIT_CAREER_FORM_TO_SLACK';

function* submitCareerFormToSlack({ form, onSuccess, onFailure }) {
  try {
    yield put(careerFormSubmitting(true));
    const careerLeadsUrl = getCareerLeadsUrl();

    const careerLeadsResponse = yield call(apiPost, careerLeadsUrl, form);
    yield put(careerFormReceived(careerLeadsResponse));

    onSuccess(careerLeadsResponse);
  } catch (e) {
    yield put(careerFormError(e.message));

    onFailure(e);
  } finally {
    yield put(careerFormSubmitting(false));
  }
}

function* rootSaga() {
  yield takeEvery(SUBMIT_CAREER_FORM_TO_SLACK, submitCareerFormToSlack);
}

export { SUBMIT_CAREER_FORM_TO_SLACK, rootSaga as default };
